module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "中奖记录"
    }
  }), _vm._v(" "), (_vm.data.length == 0) ? _c('not-data', {
    attrs: {
      "imgPic": "winning"
    }
  }) : _vm._e(), _vm._v(" "), _c('scroller', {
    ref: "scrollerBottom",
    attrs: {
      "lock-x": "",
      "height": _vm.h,
      "scroll-bottom-offst": 200,
      "id": "scroller"
    },
    on: {
      "on-scroll-bottom": _vm.onScrollBottom
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.data), function(item) {
    return _c('div', {
      staticClass: "winning-list flex",
      on: {
        "click": function($event) {
          _vm.toDetail(item.rob_id)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.image_default_id,
        "default-src": "static/placeholder.png",
        "container": "#scroller"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-1 public-gray text-l"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("本期参与 " + _vm._s(item.buy_num) + "份")]), _vm._v(" "), _c('p', [_vm._v("幸运号码 " + _vm._s(item.final_number))]), _vm._v(" "), _c('p', [_vm._v("揭晓时间 " + _vm._s(_vm._f("timerForm")(item.created_time)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex r"
    }, [_c('i', {
      staticClass: "iconfont icon-youjiantou-copy"
    })])])
  }), _vm._v(" "), (_vm.isMore) ? _c('load-more', {
    attrs: {
      "tip": "loading"
    }
  }) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-225f05b1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/winning/winning.vue
// module id = 527
// module chunks = 0